module.exports = __webpack_public_path__ + "img/icon@2x(4).fb7095bf.png";